import { Flex, Text, Button, Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';
import { formatAmount, useResponsive } from '@/shared';

import { usePaymentStatus } from '../hooks/use-payment-status';
import {
  paymentStatusTitles,
  remoteCallbackStatusTitles,
  avalableApproveStatuses,
  availableApproveCustomStatuses,
  avalableDeclineStatuses,
} from '../utils/const/common';
import { PaymentApproveForm } from './payment-approve-form';

import type { TPayment } from '../store/types';

type Props = {
  payment: TPayment;
  isLoading?: boolean;
};

export const PaymentStatus = (props: Props) => {
  const { payment } = props;
  const { isDesktop } = useResponsive();

  const {
    userRole,
    isApproveLoading,
    isDeclineLoading,
    isCancelLoading,
    handleApprovePayment,
    handleDeclinePayment,
    handleCancelPayment,
  } = usePaymentStatus();

  const isShowApproveBtn = avalableApproveStatuses.includes(payment.status);
  const isShowRemoteTypeBtn = isShowApproveBtn
    && payment.type === 'remote'
    && payment.methodMode !== 'h2h';
  const isCustomType = payment.type === 'custom';
  // const isShowCustomCancelBtn = isCustomType && isShowApproveBtn;
  const isShowDeclineBtn = avalableDeclineStatuses.includes(payment.status);
  const isShowCastomAproveBtn = isCustomType && availableApproveCustomStatuses.includes(payment.status);
  const remoteCallbackStatus = payment.remoteCallbackStatus
    ? remoteCallbackStatusTitles[payment.remoteCallbackStatus] ?? payment.remoteCallbackStatus
    : 'Получен';

  const openApproveModal = () => modals.open({
    title: 'Подтверждение платежа',
    centered: true,
    children: (
      <PaymentApproveForm
        payment={payment}
        onSubmit={handleApprovePayment}
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <Flex align={'flex-end'} direction={'column'}>
      <Text size={isDesktop ? 'sm' : 'xs'} ta="right">
        {payment.status === 'approved_wrong_amount' && !isDesktop
          ? <Text span inherit>Одобрено&nbsp;( <Text span inherit c={'red'} fw={'bold'}>{payment.paidAmount} {payment.currency}</Text> )</Text>
          : paymentStatusTitles[payment.status]
        }
        <br />
        {payment.status !== 'pending' && dayjsCustom(payment.updated).format('DD.MM в HH:mm')}
      </Text>

      {payment.remoteCallbackReceivedAt && (
        <Text size={isDesktop ? 'sm' : 'xs'} fw={'bold'} ta="right">
          Колбэк получен: {remoteCallbackStatus}
          {payment.remoteCallbackAmount && payment.remoteCallbackCurrency && (
            <>
              <br />
              {formatAmount(payment.remoteCallbackAmount)} {payment.remoteCallbackCurrency}
            </>
          )}
          <br />
          {dayjsCustom(payment.remoteCallbackReceivedAt).format('DD.MM в HH:mm')}
        </Text>
      )}

      {payment.status === 'approved' && payment.methodMode !== 'h2h' && userRole === 'admin' && (
        <Button
          variant="filled"
          color='orange'
          size="xs"
          loading={isCancelLoading}
          onClick={(e) => {
            e.stopPropagation();
            handleCancelPayment(payment.id)
          }}
        >
          Отменить
        </Button>
      )}

      {isShowRemoteTypeBtn && (
        <Group gap="xs" justify="flex-end">
          <Button
            variant="filled"
            size="xs"
            loading={isApproveLoading}
            onClick={(e) => {
              e.stopPropagation();
              openApproveModal();
            }}
          >
            Подтвердить
          </Button>
          <Button
            variant="filled"
            color='red'
            size="xs"
            loading={isDeclineLoading}
            onClick={(e) => {
              e.stopPropagation();
              handleDeclinePayment(payment.id)
            }}
          >
            Отклонить
          </Button>
        </Group>

      )}

      {isCustomType && (
        <Group gap="xs" justify="flex-end">
          {isShowCastomAproveBtn && (
            <Button
              variant="filled"
              size="xs"
              loading={isApproveLoading}
              onClick={(e) => {
                e.stopPropagation();
                openApproveModal();
              }}
            >
              Подтвердить
            </Button>
          )}

          {isShowDeclineBtn && (
            <Button
              variant="filled"
              color='red'
              size="xs"
              loading={isDeclineLoading}
              onClick={(e) => {
                e.stopPropagation();
                handleDeclinePayment(payment.id)
              }}
            >
              Отклонить
            </Button>
          )}
        </Group>
      )}

    </Flex>
  );
};
